import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { config } from './util/config';
declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  public messageInfo: string = '';
  public showNavbar;
  public user: object;
  public isLogin = false;
  public showsidemenu: boolean = true;
  public showShortcut: boolean = true;
  private open: boolean = false;
  private whiteH;

  constructor(private router: Router) {
    // listen for changes to localStorage
    window.addEventListener('storage', this.sessionStorage_transfer, false);
    // Ask other tabs for session storage (this is ONLY to trigger event)
    if (!sessionStorage.length) {
      localStorage.setItem('getSessionStorage', 'foobar');
      localStorage.removeItem('getSessionStorage');
    }
    this.user = {
      userTx: ''
    };
  }

  // transfers sessionStorage from one tab to another
  sessionStorage_transfer(event) {
    if (!event) {
      // ie suq
      event = window.event;
    }
    if (!event.newValue) {
      // do nothing if no value to work with
      return;
    }
    if (event.key === 'getSessionStorage') {
      // another tab asked for the sessionStorage -> send it
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      // the other tab should now have it, so we're done with it.
      setTimeout(() => {
        localStorage.removeItem('sessionStorage');
      }, 100);
    } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
      // another tab sent data <- get it
      const data = JSON.parse(event.newValue);
      for (const key of Object.keys(data)) {
        sessionStorage.setItem(key, data[key]);
      }
    }
  }

  ngDoCheck() {
    const result = sessionStorage.getItem('loginResult');
    if (result !== null && sessionStorage.getItem('showShortcutMenu') != null) {
      this.showNavbar = true;
      this.showsidemenu = true;
      this.showShortcut = true;
    } else {
      this.showNavbar = false;
      this.showsidemenu = false;
      if (this.router.url !== '/wa0001') this.router.navigate(['wa0001']);
    }

    if (this.router.url === '/wa0002' || this.router.url === '/wa0003') {
      this.showsidemenu = false;
    } else {
      this.showsidemenu = true;
    }
    //荷札出力画面は画面遷移を不可能とする
    if (this.router.url === '/wa3051?tab=0' || this.router.url === '/wa3051?tab=1') {
      this.showsidemenu = false;
      this.showNavbar = false;
    }    

    // 荷主ユーザ用のサイドメニュー制御
    if(result !== null) {
      let loginResult: any;
      loginResult = JSON.parse(sessionStorage.getItem('loginResult'));
      if(loginResult.user.roleId == 3 && (this.router.url === '/wa1010' || this.router.url === '/wa0053?upload_objects_id=1' || this.router.url === '/wa0053?upload_objects_id=2'
      || this.router.url === '/wa3010' || this.router.url === '/wa3017' || this.router.url === '/wa9100')) {
        this.showsidemenu = false;
      }
    }

    this.messageInfo = sessionStorage.getItem('SuccessInfoMessage');

    if (this.messageInfo !== null) {
      this.open = true;
      setTimeout(() => {
        sessionStorage.removeItem('SuccessInfoMessage');
      }, 3000);
    } else {
      this.open = false;
    }

    if (this.whiteH !== $('.is-whiteareaWrap').height()) {
      // var timer = false;
      //【is-whiteareaWrap内に変化があったら発火（主にerror用）】
      //DOMが読めなかった場合はスキップする
      if(($('.is-whiteareaWrap').get(0))!=undefined){
        var mo = new MutationObserver(function(){
            setTimeout(() => {
              //is-reHeightのclac値再計算
              var whiteH = $('.is-whiteareaWrap').height();
              var upperValue = whiteH + 'px';
              $('.is-reHeight').css({
                height: 'calc(100% - ' + upperValue + ')'
              });
            }, 200);
        });
        mo.observe($('.is-whiteareaWrap').get(0), {subtree:true, attributes:true, attributeFilter:['class', 'style']});  
      }

      //【水色検索タブがクリックされたら発火】
      $('.search__searcharea--title').click(function () {
        setTimeout(() => {
          //is-reHeightのclac値再計算
          var whiteH = $('.is-whiteareaWrap').height();
          var upperValue = whiteH + 'px';
          $('.is-reHeight').css({
            height: 'calc(100% - ' + upperValue + ')'
          });
        }, 200);
      });
      this.whiteH = $('.is-whiteareaWrap').height();
    }
  }

  ngOnInit() {
    this.verifyLogin();
    //初期表示で高さの調整
    var whiteH = $('.is-whiteareaWrap').height();
    var upperValue = whiteH + 'px';
    $('.is-reHeight').css({
      height: 'calc(100% - ' + upperValue + ')'
    });
  }

  verifyLogin() {
    const result = sessionStorage.getItem('loginResult');
    if (result !== null) {
      const resultObject = JSON.parse(result);
      this.user = resultObject.user;
      this.isLogin = true;
    } else {
      // 新規タブでURLを直接指定して開いた場合、sessionStorageから値を取得できないことがあるので、待機してから再実行
      // app.componentのsessionStorage_transferにて、sessionStorageの準備ができていないと思われる
      setTimeout(() => {
        const result = sessionStorage.getItem('loginResult');
        if (result !== null) {
          const resultObject = JSON.parse(result);
          this.user = resultObject.user;
          this.isLogin = true;
        } else {
          sessionStorage.clear();
          this.isLogin = false;
          this.router.navigate(['wa0001']);
        }
      }, config.waitMsForSessionInHeaderVerifyLogin);
    }
  }
  messageBox() {
    let classes = {
      messageBox: true,
      'messageBox-open': this.open
    };
    return classes;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/app.component.ts